module.exports = __webpack_public_path__ + "img/productImg.0af67687.png";